(() => {
  if (!document.getElementById("SidebarMenu")) {
    return false;
  }

  var getSiblings = function (elem) {
    var siblings = [];
    var sibling = elem.parentNode.firstChild;

    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== elem) {
        siblings.push(sibling);
      }
      sibling = sibling.nextSibling;
    }

    return siblings;
  };

  // Expand / Contract the menu (menu toggle)

  const menuToggler = document.getElementById("sidebarToggle");
  const sideMenu = document.getElementById("SidebarMenu");

  menuToggler.addEventListener("click", function () {
    if (sideMenu.classList.contains("is-closed")) {
      openSidebar();
    } else {
      closeSidebar();
    }
  });

  function openSidebar() {
    sideMenu.classList.remove("is-closed");
    sideMenu.classList.add("is-open", "is-animation-open");
    setTimeout(function () {
      sideMenu.classList.remove("is-animation-open");
    }, 550);
  }

  function closeSidebar() {
    sideMenu.classList.add("is-closed", "is-animation-close");
    sideMenu.classList.remove("is-open");

    setTimeout(function () {
      sideMenu.classList.remove("is-animation-close");
    }, 500);
  }

  // Select Page

  var navItem = document.getElementsByClassName("js-navitem");

  for (var i = 0; i < navItem.length; i++) {
    navItem[i].addEventListener("click", selectPage, false);
  }

  function iframeRef(frameRef) {
    return frameRef.contentWindow
      ? frameRef.contentWindow.document
      : frameRef.contentDocument;
  }

  function selectPage() {
    var siblings = getSiblings(this);
    const target = this.getAttribute("data-target");
    const frame = document.getElementById(target);

    if (target === "target-map") {
      document.getElementById("homepage").classList.add("is-fixed");
    } else {
      document.getElementById("homepage").classList.remove("is-fixed");
    }

    const frameSiblings = getSiblings(frame);

    var inside = iframeRef(document.getElementById("target-smart-tech"));

    const videoPlayer = inside.getElementById("video-player");

    if (videoPlayer) {
      videoPlayer.pause();
    }

    frame.style.display = "block";
    this.classList.add("is-selected");

    for (var x = 0; x < frameSiblings.length; x++) {
      frameSiblings[x].style.display = "none";
    }

    for (var i = 0; i < siblings.length; i++) {
      siblings[i].classList.remove("is-selected");
    }
  }
})();
